import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import React from 'react';

import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';

import { historicalPercentageChangeCapsuleDescription } from './components/description/historicalPercentageChangeCapsuleDescription';
import { initialHistoricalPercentageChangeCapsuleConfigState } from './store';
import { HistoricalPercentageChangeConfig } from '../store/HistoricalPercentageChangeConfig';
import { HistoricalPercentageChangeCapsule } from './components/HistoricalPercentageChangeCapsule';
import { histPriceVolStreamConfig } from '../store/data/stream-config';
import { WidgetStrategyWithCustomManagedStream } from 'widgets/WidgetRegistry';
import { HistoricalPercentageChangeCapsuleSettings } from './components/HistoricalPercentageChangeCapsuleSettings';
import { histPriceVolStreamedDataSelectors } from '../store/data/streamSlice';
import { HistoricalPercentageChangeMyPortfolioCapsuleContent } from './components/HistoricalPercentageChangeMyPortfolioCapsuleContent';

const useMessagesInMyPortfolioCapsules = (symbol: string) =>
    histPriceVolStreamedDataSelectors.useStreamedDataMessages(
        symbol,
        initialHistoricalPercentageChangeCapsuleConfigState
    );

export const historicalPercentageChangeCapsuleStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<HistoricalPercentageChangeConfig> &
    WidgetStrategyWithCustomManagedStream = {
    title: 'Historical Percentage Change',
    supportedHosts: ['tile'],
    reactComponentType: HistoricalPercentageChangeCapsule,
    myPortfolioCapsuleContentReactComponentType:
        HistoricalPercentageChangeMyPortfolioCapsuleContent,
    categories: [WidgetCategory.TOP],
    description: historicalPercentageChangeCapsuleDescription,
    initialConfigState: initialHistoricalPercentageChangeCapsuleConfigState,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    renderSettingsBody,
    managedStreamConfig: histPriceVolStreamConfig,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.PositionFromAtLeastOneOrder,
    portfolioSelectionRequirementsWithoutOrdersStream:
        PortfolioSelectionRequirements.SingleSymbol,
    useMessagesInMyPortfolioCapsules,
    wideTitle: true,
};

function renderSettingsBody(
    config: HistoricalPercentageChangeConfig,
    onChange: (configDelta: Partial<HistoricalPercentageChangeConfig>) => void
) {
    return (
        <HistoricalPercentageChangeCapsuleSettings
            config={config}
            onChange={onChange}
        />
    );
}
